import { attach, createEvent, createStore, sample } from 'effector'
import { CategoryId } from '~/entities/epg/categories'
import { epgChannelsModel } from '~/entities/epg/channels'
import { exists } from '~/shared/helpers'
import { LOAD_MORE_COUNT } from './index.h'

// load more channels by category id
export const load = createEvent<{ categoryId: number }>()

// load more channels list effect
export const loadMoreChannelsFx = attach({
  mapParams: ({ categoryId, page }: { categoryId: number; page: number }) => ({
    'byCategoryId': categoryId,
    'categoryId': categoryId === CategoryId.Favorite ? undefined : categoryId,
    'only-favorites': categoryId === CategoryId.Favorite ? true : undefined,
    'page': page,
    'count': LOAD_MORE_COUNT,
  }),
  effect: epgChannelsModel.loadPageFx,
})

export const $pending = createStore<[Map<number, boolean>]>([new Map()])

sample({
  clock: loadMoreChannelsFx,
  source: $pending,
  fn: (pending, { categoryId }) => {
    const [map] = pending
    map.set(categoryId, true)

    return [map] as const
  },
  target: $pending,
})

sample({
  clock: loadMoreChannelsFx.finally,
  source: $pending,
  fn: (pending, { params: { categoryId } }) => {
    const [map] = pending
    map.delete(categoryId)

    return [map] as const
  },
  target: $pending,
})

// load more channels - uses page number from API response
sample({
  clock: load,
  source: {
    loaded: epgChannelsModel.$byCategory,
    pending: epgChannelsModel.loadPageFx.pending,
  },
  filter: ({ loaded: [_, meta], pending }, { categoryId }) =>
    !pending && Boolean(meta.get(categoryId)?.hasMore),
  fn: ({ loaded: [_, meta] }, { categoryId }) => {
    const categoryMeta = meta.get(categoryId)
    const nextPage = exists(categoryMeta?.page)
      ? Number(categoryMeta!.page) + 1
      : 0

    return {
      categoryId,
      page: nextPage,
    }
  },
  target: loadMoreChannelsFx,
})
